import { Component, Output, EventEmitter, OnInit, Input, SimpleChanges, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Service } from './ctl-tem-hesap-arama.service';
import { DxButtonModule } from 'devextreme-angular';
import { ColumnModel } from '@dabnet-kamu/libs/ui';
import { DkDxDataCtlTableComponent } from '../../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { DlistDto } from '@dabnet-kamu/libs/ui';
import { Observable } from 'rxjs';
import { TemHesapService } from '../ctl-tem-hesap.service';
import { OrtakService } from '@dabnet-kamu/libs/ui';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dk-ctl-tem-hesap-arama',
  templateUrl: './ctl-tem-hesap-arama.component.html',
  styleUrls: ['./ctl-tem-hesap-arama.component.scss'],
  standalone: true,
  imports: [DkDxDataCtlTableComponent, DxButtonModule,CommonModule],
  providers: [Service],
})
export class CtlTemHesapAramaComponent implements OnInit   {
  private destroyRef = inject(DestroyRef);
  @Input() filterColumn = "";
  @Input() filterColumnValue: any='';
  public data: any;
  public columns: ColumnModel[];
  public selectedData: any = null;
  gridControlsList$: Observable<DlistDto>;
  @Input() control: any;
  @Output() private closePopup = new EventEmitter<string>();
  public filterValue:any

  constructor(
    private service: Service,
    private temHesapService:TemHesapService,
    public ortakService:OrtakService
  ) {

  }

  ngOnInit(): void {
    if(this.filterColumnValue){
      this.filterValue = [this.filterColumn, 'startswith', this.filterColumnValue]
    }
    this.data = this.service.getData(this.control);
    this.gridControlsList$ = this.temHesapService.gridControlsList$;
    this.temHesapService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x=>{
      this.columns = this.ortakService.setRecursiveFieldData([x],false);
      })
  }

  ngOnChanges(changes: SimpleChanges): void {

  }


  focusChanged(e: any) {
    this.selectedData = e.row;
  }

  
  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.filterColumnValue = undefined;
      this.closePopup.emit(this.selectedData);
    }
  }
  
  dblClickRow(e:any){
    this.filterColumnValue = undefined;
    this.closePopup.emit(e);
  }
  chooseBtnClick() {
    this.filterColumnValue = undefined;
    this.closePopup.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.filterColumnValue = undefined;
    this.closePopup.emit(null);
  }
}
